import { ClientPrivileges } from "../authentication/ClientPrivilegesEnum";

export enum NotificationTopicEnum {
    NewInstallationRegistration = 0,
    ContentThresholdWarning = 1,
    OutOfServiceStatus = 2,
    CleanThresholdWarning = 3,
    OneTimeCodeNotifications = 4,
    BagFillPercentExceededWarning = 5,
    IntegrationExceptionWarning = 6,
}

export function topicNeedInstallations(topic: NotificationTopicEnum): boolean {
    let topicNoInstallationsNeeded = [NotificationTopicEnum.NewInstallationRegistration, NotificationTopicEnum.IntegrationExceptionWarning];
    return !topicNoInstallationsNeeded.includes(topic);
}

export function topicToType(topic: NotificationTopicEnum): string {
    switch (topic) {
        case NotificationTopicEnum.IntegrationExceptionWarning:
            return "common.license_module.integration";
        case NotificationTopicEnum.ContentThresholdWarning:
        case NotificationTopicEnum.BagFillPercentExceededWarning:
            return "common.license_module.cash_flow_management";
        case NotificationTopicEnum.OneTimeCodeNotifications:
            return "common.license_module.one_time_code";
        case NotificationTopicEnum.NewInstallationRegistration:
        case NotificationTopicEnum.OutOfServiceStatus:
        case NotificationTopicEnum.CleanThresholdWarning:
        default:
            return "device_status.page_title";
    }
}

export function topicToPrivilege(topic: NotificationTopicEnum): ClientPrivileges {
    switch (topic) {
        case NotificationTopicEnum.IntegrationExceptionWarning:
            return ClientPrivileges.CashFlowTransactionsReporting;
        case NotificationTopicEnum.ContentThresholdWarning:
        case NotificationTopicEnum.BagFillPercentExceededWarning:
            return ClientPrivileges.CashFlowContentMonitoring;
        case NotificationTopicEnum.OneTimeCodeNotifications:
            return ClientPrivileges.SmartLockManagement;
        case NotificationTopicEnum.NewInstallationRegistration:
        case NotificationTopicEnum.OutOfServiceStatus:
        case NotificationTopicEnum.CleanThresholdWarning:
        default:
            return ClientPrivileges.StatusManagement;
    }
}
